import { Hero } from '../components/Hero';
import { FeaturedWork } from '../components/FeaturedWork';
import { About } from '../components/About';
import { Experience } from '../components/Experience';
import { Tools } from '../components/Tools';
import { DesignerValues } from '../components/DesignerValues';
import { TextileDivider } from '../components/Ornaments';

export default function HomePage() {
  return <main id="main-content" data-testid="home-page"><Hero /><FeaturedWork /><TextileDivider /><About /><Experience /><Tools /><DesignerValues /></main>;
}